<template>
    <div :style="[basicContentStyles]">
        <div v-if="data.index_html" style="height: 100%">
            <iframe
                :id="'widget-live-preview-' + index"
                :key="'widget-live-preview-' + data.index_html + (data.query_string ? data.query_string : '')"
                :style="[iframeStyles]"
                :src="data.index_html + (data.query_string ? data.query_string : '')"
                sandbox="allow-scripts allow-same-origin"></iframe>
            <div style="width:100%;height:100%;position:absolute;top:0;">

            </div>
        </div>
        <img v-else
             class="widget-background-image-template"
             :src="data.background_image"
             alt="Widget Thumbnail">
    </div>
</template>

<script>
    export default {
        props: [
            'index',
            'data',
            'frame',
            'basicContentStyles',
            'width',
            'height'
        ],
        data: function () {
            return {
                query: '',
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    backgroundImage: 'url("' + this.data.background_image + '")',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    opacity: opacity,
                };
            },
            iframeStyles: function () {
                let ratio = this.frame.ratio * this.width/this.frame.width;
                return {
                    width: this.width / ratio + 'px',
                    height: this.height / ratio + 'px',
                    '-webkit-transform': 'scale(' + ratio + ')',
                    '-webkit-transform-origin': '0 0',
                    'z-index': -1,
                    border: 20,
                }
            }
        },
    }
</script>

<style>
.widget-background-image-template {
    height: 100%;
    width: 100%;
    object-fit: cover;
    text-align: center;
}
</style>
